import { useMutation } from '@tanstack/react-query';
import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationDynamicSystemsAllowedForDeskCell({
    rowData,
    onChange,
}: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: setDynamicSystemsAllowedForDesk, isPending } = useMutation({
        meta: { name: 'update-location' },
        mutationFn: (value: boolean) =>
            updateLocation(rowData, { DynamicSystemsAllowedForDesk: value }),

        onSuccess: (updatedLocation) => {
            showToast({
                type: 'success',
                content: `Successfully ${
                    updatedLocation.DynamicSystemsAllowedForDesk ? 'enabled' : 'disabled'
                } desk dynamic system associations`,
            });
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save desk dynamic system association status',
            }),
    });

    return (
        <SwitchInlineEditor
            value={rowData.DynamicSystemsAllowedForDesk}
            onConfirm={(val) => setDynamicSystemsAllowedForDesk(val ?? false)}
            isDisabled={isPending || !canEditLocationDetails}
            renderValue={(val) => (val ? 'Yes' : 'No')}
        />
    );
}
